import { apiRequest } from '@/src/services';

function appendFormData(formData: FormData, data: any, parentKey = '') {
    if (data === null || data === undefined) {
        return;
    }

    if (Array.isArray(data)) {
        data.forEach((value, index) => {
            const key = parentKey ? `${parentKey}[${index}]` : `[${index}]`;
            appendFormData(formData, value, key);
        });
    } else if (typeof data === 'object') {
        Object.keys(data).forEach((key) => {
            const value = data[key];
            const newKey = parentKey ? `${parentKey}.${key}` : key;
            appendFormData(formData, value, newKey);
        });
    } else {
        formData.append(parentKey, data);
    }
}

export async function submitForGrading(question: any, userResponse: string): Promise<any> {
    const url = 'assessments/questions/utils/gradeQuestion';

    const formData = new FormData();

    appendFormData(formData, question);
    appendFormData(formData, userResponse);

    const apiHeaders = { 'Content-Type': 'multipart/form-data' };
    const response = await apiRequest('post', url, formData, apiHeaders);
    return response.data;
}
